export default {
    name: "Alert",
    title: "Alert",
    icon: "mdi-alert-circle-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            message: ""
        };
    },
};